import React from 'react';
import PropTypes from 'prop-types';
import HorseDefinition from '../../../shared/HorseDefinition';

const FamilyTreeSummary = ({ sire, dam }) => (
    <dl className="hidden-md-up">
        {sire && <HorseDefinition
            {...sire}
            term="Sire"
            avgFlatWinDist={sire.avgFlatWinDistOfProgeny}
        />}
        {dam && <HorseDefinition
            {...dam}
            term="Dam"
            avgFlatWinDist={dam.avgFlatWinDistOfProgeny}
        />}
        {dam && dam.sire && <HorseDefinition
            {...dam.sire}
            term="Dam's Sire"
            avgFlatWinDist={dam.sire.avgFlatWinDistOfProgeny}
        />}
    </dl>
);

const horseTypes = {
    avgFlatWinDistOfProgeny: PropTypes.number,
    countryOriginCode: PropTypes.string,
    horseName: PropTypes.string,
    horseUid: PropTypes.number,
};
FamilyTreeSummary.propTypes = {
    sire: PropTypes.shape(horseTypes),
    dam: PropTypes.shape({
        ...horseTypes,
        sire: PropTypes.shape(horseTypes),
    }),
};

export default FamilyTreeSummary;



// WEBPACK FOOTER //
// ./src/js/horse/pedigree/familyTree/FamilyTreeSummary.jsx